export const config = {
    appname: 'burgerking',
    client_id: '1351788021633457', // App ID
    facebook_app_id: '1351788021633457', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Production Settings ----------------
    api: 'apibgk2',
    agency_id: '7331',
    bzbsUrlOldSupport: 'https://api.buzzebees.com',
    bzbsUrl: 'https://apibgk2.buzzebees.com',
    bzbsModuleUrl: 'https://burgerkingmodule.buzzebees.com',
    bkDeliveryModuleUrl: 'https://deliverymodule9.buzzebees.com',
    apiShoppingCartUrl: 'https://shoppingcartmodule9.buzzebees.com',
    webShoppingCartUrl: 'https://shoppingcartservice9.buzzebees.com',
    bzbsBlobUrl: 'https://cdn.buzzebees.com/th',
    miscUrl: 'https://misc.buzzebees.com',
    bzbsGaId: '',
    liffId: '',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],

    minorPrivacyUrl: {
        th: 'https://www.minorfood.com/th/privacy/dsar',
        en: 'https://www.minorfood.com/en/privacy/dsar',
    },

    firebase: {
        apiKey: "AIzaSyBExH8_4uuyRxDYRKIJbMRWHKMvs-EjLq4",
        authDomain: "mfg-burger-king.firebaseapp.com",
        projectId: "mfg-burger-king",
        storageBucket: "mfg-burger-king.appspot.com",
        messagingSenderId: "419085708372",
        appId: "1:419085708372:web:546ff15c3d714e9bc591c1"
    },
};
